import React, { FC } from 'react'
import intl from 'react-intl-universal'
import { AnnotationFormData } from '../../types'

interface ActionButtonsProps {
  cancel: () => void
  applyAnnotation: () => void
  isEditting: boolean
  annotationFormData: AnnotationFormData
  formTouched: boolean
}

const ActionButtons: FC<ActionButtonsProps> = ({
  cancel,
  applyAnnotation,
  isEditting,
  annotationFormData,
  formTouched,
}) => {
  const submitButtonEnabled = (): boolean => {
    const formData = annotationFormData
    if (!formTouched) return false
    // If the category and the item are selected
    if (formData.category && formData.item) {
      // check if at least one child is selected
      // Here we compare children = [] || children = undefined
      if (formData.item.value.children) {
        if (formData.item.value.children.length > 0) {
          return formData.child !== undefined
        }
        // If there are no children, it's valid
        return true
      } else {
        return true
      }
    }
    return false
  }

  return (
    <div className="annotation-modal-buttons">
      <div className="row align-items-center justify-content-end">
        <button
          onClick={cancel}
          className="ads-btn ads-outline"
          id="annotation-modal-cancel"
        >
          {intl.get('annotationPlugin.modal.button.cancel')}
        </button>
        <button
          type="button"
          disabled={!submitButtonEnabled()}
          onClick={applyAnnotation}
          className="ads-btn ads-primary-sm"
          id="annotation-modal-submit-button"
        >
          {isEditting
            ? intl.get('annotationPlugin.modal.button.updateAnnotation')
            : intl.get('annotationPlugin.modal.button.addAnnotation')}
        </button>
      </div>
    </div>
  )
}

export default ActionButtons
